


















import { Component, Vue } from 'vue-property-decorator'

// service
import { Datasource } from '../services/datasource'

@Component({
  components: {
  },
})
export default class extends Vue {
  requestMigrate() {
    Datasource.shared.migrate()
      .then((migrationResult) => {
        console.log('Migrated with ', migrationResult)
      })
  }
}
